// Interface to set a game score for Scheduler

import { useState } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import Input from './Input';
import Spinner from './Spinner';
import { useFirebase } from './FirebaseContextProvider';
import { useModal } from './ModalProvider';
import { tournamentGameUpdate } from '../utils/firebase';
import placeholderTeam from '../assets/images/placeholder-team.png';
import './GameBlockScore.scss';

export default function GameBlockScore({ id, game }) {
  const [spinner, setSpinner] = useState(false);
  const { teamsById } = useFirebase();
  const { closeModal } = useModal();

  const t1 = teamsById.get(game.team1);
  const t2 = teamsById.get(game.team2);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      score1: game.score1 != null ? game.score1 : '',
      score2: game.score2 != null ? game.score2 : '',
    },
    validationSchema: Yup.object({
      score1: Yup.string().matches(/^\d*$/, 'Invalid'),
      score2: Yup.string().matches(/^\d*$/, 'Invalid'),
    }),
    onSubmit: async (values) => {
      setSpinner(true);
      try {
        await tournamentGameUpdate({
          id,
          gameId: game.id,
          score1: values.score1 !== '' ? values.score1 : null,
          score2: values.score2 !== '' ? values.score2 : null,
        });
        closeModal();
        formik.resetForm();
      } catch (err) {
        toast.error(err?.message ?? 'Failed to save score');
      } finally {
        setSpinner(false);
      }
    },
  });

  return (
    <form className='game-block-score-form' onSubmit={formik.handleSubmit}>
      <div className='input-wrap'>
        <div className='team1'>
          <div className='team-header'>
            <div
              className='bg-image wh-32'
              style={{
                backgroundImage: `url(${t1?.imgThumbUrl || placeholderTeam})`,
              }}
            />
            <p className='font-medium'>{t1?.name || 'TBD'}</p>
          </div>
          <Input
            name='score1'
            placeholder='Score'
            type='number'
            {...formik.getFieldProps('score1')}
            error={
              formik.touched.score1 && formik.errors.score1
                ? formik.errors.score1
                : null
            }
          />
        </div>
        <div className='team2'>
          <div className='team-header'>
            <div
              className='bg-image wh-32'
              style={{
                backgroundImage: `url(${t2?.imgThumbUrl || placeholderTeam})`,
              }}
            />
            <p className='font-medium'>{t2?.name || 'TBD'}</p>
          </div>
          <Input
            name='score2'
            placeholder='Score'
            type='number'
            {...formik.getFieldProps('score2')}
            error={
              formik.touched.score2 && formik.errors.score2
                ? formik.errors.score2
                : null
            }
          />
        </div>
      </div>
      <Spinner show={spinner} />
      <div className='actions'>
        <button className='signin-btn' disabled={spinner}>
          Set
        </button>
      </div>
    </form>
  );
}
